import React, { useState } from 'react';

import { useQuery } from '@tanstack/react-query';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';

import Tabs from './Tabs';
import CompanyHeader from './CompanyHeader';

import AdminService from '../../../../../services/AdminService';

import classes from './styles.module.scss';
import backIcon from '../../../../../assets/images/dashboard/jobs/back.svg';
import longBackIcon from '../../../../../assets/images/dashboard/jobs/back-with-arrow.svg';
import Details from './Details';
import Activities from './Activities';
// import Rules from './Rules';
import Settings from './Settings';

export default function CompanyDetails() {
  const { '*': companyId } = useParams();

  const navigate = useNavigate();

  const { t } = useTranslation();
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1024px)' });

  const [currentTab, setCurrentTab] = useState(
    t('dashboardComponents.Companies.CompanyDetails.details')
  );

  const { data: company, refetch: refetchCompany } = useQuery({
    queryKey: ['companyDetails', companyId],
    queryFn: () => AdminService.getCompanyDetails({ id: companyId }),
  });

  return (
    <div className={classes.CompanyDetails}>
      <button
        type="button"
        className={classes.backButton}
        onClick={() => navigate('/tools/companies')}
      >
        <img src={isTabletOrMobile ? backIcon : longBackIcon} alt="back" />

        {t('dashboardComponents.Companies.CompanyDetails.backToList')}
      </button>
      <CompanyHeader company={company} refetchCompany={refetchCompany} />
      <div className={classes.tableContainer}>
        <Tabs currentTab={currentTab} setCurrentTab={setCurrentTab} />
        {currentTab ===
          t('dashboardComponents.Companies.CompanyDetails.details') && (
          <Details company={company} refetch={refetchCompany} />
        )}
        {currentTab ===
          t('dashboardComponents.Companies.CompanyDetails.activites') && (
          <Activities company={company} />
        )}
        {/* {currentTab ===
          t('dashboardComponents.Companies.CompanyDetails.rules') && <Rules />} */}
        {currentTab ===
          t('dashboardComponents.Companies.CompanyDetails.settings') && (
          <Settings company={company} refetchCompany={refetchCompany} />
        )}
      </div>
    </div>
  );
}
